import cn from 'classnames';

import styles from './PublicMainLawInfoItem.module.scss';

interface IPublicMainLawInfoItemProps {
  className?: string;
  name?: string;
  text?: string;
  expanded?: boolean;
}

export const PublicMainLawInfoItem = ({ className, name, text, expanded }: IPublicMainLawInfoItemProps) => {
  const itemClassNames = cn(styles.Item, className);

  return (
    <div className={itemClassNames}>
      <span className={styles.Name}>{name}</span>
      <span className={cn(styles.Text, { [styles.TextHidden]: !expanded })}>{text}</span>
    </div>
  );
};
